export default __webpack_public_path__ + "static/media/PAGES24.2776aa5e.png";